import classNames from 'classnames';
import { autobind } from 'core-decorators';
import { easeQuadInOut } from 'd3-ease';
import PropTypes from 'prop-types';
/* eslint-disable max-len */
import { Component } from 'react';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import { connect } from 'react-redux';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { getCurrentPorcentageValue } from '/@/store/loading-counter/selectors';
import 'react-circular-progressbar/dist/styles.css';
import AppLogo from '/@/components/app-logo';
import colorsTheme from '/@/components/theme-provider/colors';
import AnimatedProgressProvider from './animated-progress-provider';
import * as notes from './notes';
import RotateItems from './rotate-items';
import styles from './styles.module.css';

@connect((state) => {
    return { offline: state.network.offline, porcentageCount: getCurrentPorcentageValue(state) };
})
@autobind
export default class Loading extends Component {
    static propTypes = {
        offline: PropTypes.bool,
        className: PropTypes.string,
    };

    getColorAppInstance() {
        const colors = {
            cultivio: '#30976b',
            latijereta: '#006bb6',
            agroeste: '#2864a2',
            agroceres: '#006935',
            md: colorsTheme.themes.md.primary.default,
            expertobayer: colorsTheme.themes.expertobayer.primary.default,
            fieldview: colorsTheme.themes.fieldview.primary.default,
        };
        return colors[settings.app.theme];
    }

    render() {
        const note = notes.textsES;
        return (
            <div className={classNames(styles.root, this.props.className)}>
                <div className={styles.container}>
                    <AppLogo classNameImage={styles.appLogo} />
                    <div className={styles.circularProgress}>
                        <AnimatedProgressProvider valueStart={0} valueEnd={100} easingFunction={easeQuadInOut}>
                            {() => {
                                const porcentage = this.props.porcentageCount;
                                return (
                                    <CircularProgressbar
                                        value={porcentage}
                                        text={`${Math.min(porcentage, 100)}%`}
                                        strokeWidth={5}
                                        /* This is important to include, because if you're fully managing the
                                        animation yourself, you'll want to disable the CSS animation. */
                                        styles={buildStyles({
                                            pathTransition: 'none',
                                            textColor: this.getColorAppInstance(),
                                            pathColor: this.getColorAppInstance(),
                                        })}
                                    />
                                );
                            }}
                        </AnimatedProgressProvider>
                    </div>
                    <div className={classNames(styles.container, styles.containerTexts)}>
                        <RotateItems items={note} />
                    </div>
                </div>
                {this.props.offline && (
                    <div className={styles.message}>
                        <div>
                            {_(
                                'Detectamos que tenés una conexión lenta a internet. Por favor esperá un poco más mientras sincronizamos los datos de la app.'
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
